import React, { useEffect, createElement, Component } from 'react';
import { Toaster } from 'sonner';
import { CONSTANTS } from './utils/constants';
// Components
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel securely
    try {
      // @ts-ignore
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ?
          // @ts-ignore
          n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        // @ts-ignore
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        // @ts-ignore
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        // @ts-ignore
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        // @ts-ignore
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      // @ts-ignore
      fbq('init', CONSTANTS.PIXEL_ID);
      // @ts-ignore
      fbq('track', 'PageView');
    } catch (e) {
      console.error('Error initializing Meta Pixel', e);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <Toaster data-id="element-1" />
      <PurchasePopup data-id="element-2" />
      <StickyBar data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <SocialProof data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <WhatIsIncluded data-id="element-8" />
        <BonusSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <UrgencySection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
    </div>;
}